<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/supplier">Fornecedores</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Atualizar endereço</li>
                <li class="breadcrumb-item active" aria-current="page">{{ supplier.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <router-link :to="{
                            name: 'supplier_edit',
                            params: { id: this.supplier.id }
                        }" role="tab" data-toggle="tab" class="nav-link"> Dados gerais </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{
                            name: 'supplier_address_edit',
                            params: { id: this.supplier.id }
                        }" role="tab" data-toggle="tab" class="nav-link active">
                            Endereço </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{
                            name: 'supplier_fiscal_edit',
                            params: { id: this.supplier.id }
                        }" role="tab" data-toggle="tab" class="nav-link">
                            Dados fiscais </router-link>
                    </li>

                </ul>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <form @submit="update">
                                    <fieldset>
                                        <legend>Endereço</legend>
                                    <div class="row mt-2">
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">CEP</label>

                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx-xxx"
                                                    v-model="supplier_address.zipcode" v-mask="['#####-###']">
                                                <div class="input-group-append">
                                                    <button class="btn btn-success" type="button" id="button-addon2"
                                                        @click="searchZipcode()"><i class="fa fa-search"></i>Buscar
                                                        CEP</button>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-xl-7 col-md-7 col-sm-12">
                                            <label for="">Endereço*</label>
                                            <input type="text" class="form-control" placeholder="Ex: Av. Paulista"
                                                v-model="supplier_address.street">
                                        </div>
                                        <div class="col-xl-2 col-md-2 col-sm-12">
                                            <label for="">Nº</label>
                                            <input type="text" class="form-control" placeholder="Ex: 100"
                                                v-model="supplier_address.number_street">
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <label for="">Complemento</label>
                                            <input type="text" class="form-control" placeholder="Ex: Próximo à...."
                                                v-model="supplier_address.complement">
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Bairro</label>
                                            <input type="text" class="form-control" placeholder="Ex: Centro"
                                                v-model="supplier_address.district">
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Cidade</label>
                                            <input type="text" class="form-control" placeholder="Ex: São Paulo"
                                                v-model="supplier_address.city">
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">UF</label>
                                            <input type="text" class="form-control" placeholder="Ex: SP"
                                                v-model="supplier_address.uf">
                                        </div>
                                    </div>
                                   </fieldset>
                                    <br>
                                    <fieldset>
                                        <legend>Obvervações</legend>
                                     <div class="row mt-2 mb-4">
                                        <div class="col-lg-12 col-xs-12 col-sm-12">
                                            <editorText @update-text="updateObservation"
                                                :modelValue="supplier_address.observation" placeholderSend="Sem observações" ref="myChild"></editorText>
                                        </div>
                                    </div>
                                <br> <br>
                                </fieldset>
                                    
                                    <div class="row mt-3">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                    class="fa fa-save"></i> Atualizar</button>
                                            <router-link to="/supplier" class="btn btn-danger ml-3"><i
                                                    class="fa fa-times"></i>
                                                Cancelar</router-link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { loadZipcode } from '@/api-external';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import editorText from '../util/editor-text.vue';

export default {
    directives: { mask },
    components: { Loading, editorText },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            supplier: {},
            supplier_id:'',
            supplier_address: {
                id: '',
                zipcode: '',
                street: '',
                number_street: '',
                complement: '',
                district: '',
                city: '',
                uf: '',
                observation: ''
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.supplier_address.street != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.supplier_id = id;
        this.getAddressSupplier();
    },
    methods: {
        onCancel() { },
        searchZipcode() {
            this.isLoading = true;
            if (this.supplier_address.zipcode.length > 0) {
                let zipcode = this.supplier_address.zipcode.replace(/\D/g, '');
                loadZipcode(zipcode).then((response) => {
                    this.supplier_address.street = response.street;
                    this.supplier_address.district = response.neighborhood;
                    this.supplier_address.city = response.city;
                    this.supplier_address.uf = response.state;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                });
            } else {
                this.$notify({
                    title: "Informação",
                    text: "Informe um CEP válido",
                    type: 'info'
                });
            }
        },
        updateObservation(observation) {
           this.supplier_address.observation = observation;
        },
        getAddressSupplier() {
            api.get('/supplier/' +  this.supplier_id + '/address')
                .then((response) => {
                    this.isLoading = false;
                    this.supplier = response.data.supplier;
                    if (response.data.address_supplier.length != 0) {
                        this.supplier_address = response.data.address_supplier;
                        this.$refs.myChild.updateTextEditor(this.supplier_address.observation);
                    }

                     

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        update(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/supplier/' + this.supplier.id + '/address', this.supplier_address)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Endereço do fornecedor atualizado com sucesso!",
                        type: 'success'
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        }
    }
}
</script>

<style lang="scss" scoped></style>